import React from 'react';
import { Link } from 'react-router-dom';

export default function BackToList({ to, label }) {
    return (
        <div className="gs-back-nav">
            <Link to={to} className="gs-back-nav__link">
                ← {label}
            </Link>
        </div>
    );
}
